import script from "./Guide.vue?vue&type=script&setup=true&lang=js"
export * from "./Guide.vue?vue&type=script&setup=true&lang=js"

import "./Guide.vue?vue&type=style&index=0&id=172014c0&lang=scss&scoped=true"

import exportComponent from "/home/nootaku/dev/clickado_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172014c0"]])

export default __exports__